import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from './private/dashboard/dashboard.component';
import { AvailabilityComponent } from './private/availability/availability/availability.component';

import { PurchaseByAdforceComponent } from './private/purchase/purchase-by-adforce/purchase-by-adforce.component';

export const routes: Routes = [
  { path: '', component: DashboardComponent },
  { path: 'availabilities', component: AvailabilityComponent },
  { path: 'create/purchaseByAdforce', component: PurchaseByAdforceComponent },
  { path: 'create/purchaseByAdforce/:data', component: PurchaseByAdforceComponent },
  { path: 'offers', loadChildren: './private/offer/offer.module#OfferModule'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
